import { isMobileViewport } from '../styles/breakpoints'

import { showMobileFloorMapUnavailableModal } from './mobileFloorMapModalController'

export const MOBILE_FLOOR_MAP_UNAVAILABLE_MESSAGE =
  'This feature is currently not available for mobile devices.'

export function isMobileFloorMapBlocked(): boolean {
  return isMobileViewport()
}

export function alertMobileFloorMapUnavailable(): void {
  showMobileFloorMapUnavailableModal()
}

/** Returns true when navigation should be aborted (mobile + alert shown). */
export function blockMobileFloorMapNavigation(): boolean {
  if (!isMobileFloorMapBlocked()) {
    return false
  }
  alertMobileFloorMapUnavailable()
  return true
}
